import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_COMPANY, isCompanyId } from "../prototype/fixtures";
import { InboxScreen } from "../screens/InboxScreen";
import { inboxSearch } from "../screens/inboxSearch";

export const Route = createFileRoute("/prototype/c/$companyId/inbox/")({
  validateSearch: (search) => inboxSearch.parse(search),
  component: DocumentInbox,
});

function DocumentInbox() {
  const { companyId } = Route.useParams();
  const { tab, upload, item } = Route.useSearch();
  return (
    <InboxScreen
      companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY}
      tab={tab}
      upload={upload === true}
      itemId={item}
    />
  );
}
